import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  languages: []
}

// getters
export const getters = {
  languages: state => state.languages
}

// mutations
export const mutations = {
  [types.FETCH_LANGUAGES_SUCCESS] (state, { languages }) {
    state.languages = languages
  },

  [types.FETCH_LANGUAGES_FAILURE] (state) {
    state.LANGUAGES = []
  }
}

// actions
export const actions = {
  async fetchLanguages ({ commit }) {
    try {
      const response = await axios.get(`/api/languages`)

      commit(types.FETCH_LANGUAGES_SUCCESS, { languages: response.data })
    } catch (error) {
      console.error(error)
      commit(types.FETCH_LANGUAGES_FAILURE)
    }
  }
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/languages.js